import { useCallback, useEffect } from 'react';
import { config } from '@/config';

export const useYotiWatchHandler = (
    onSuccess: () => void | Promise<void>,
    onError?: () => void | Promise<void>,
) => {
    const yotiStatusWatchHandler = useCallback(
        (evt: MessageEvent<{ eventType: string }>) => {
            const type = evt?.data?.eventType;
            if (
                !type ||
                evt.origin !== config.api.url.yotiApi ||
                (type !== 'SUCCESS' && type !== 'ERROR')
            ) {
                return;
            }
            if (type === 'SUCCESS') {
                void onSuccess();
            }
            if (type === 'ERROR') {
                void onError?.();
            }
        },
        [onError, onSuccess],
    );

    useEffect(() => {
        window.addEventListener('message', yotiStatusWatchHandler);
        return () => window.removeEventListener('message', yotiStatusWatchHandler);
    }, [yotiStatusWatchHandler]);
};
